customElements.define("variant-option-selector", class extends HTMLElement {

    constructor() {
      super({ name: "Variant option selector", version: "v1.0.0" });
      this.selectElem = this.querySelector('#size-selector-size')
    }

    connectedCallback() {
      this.setEventListeners();
      if (this.selectElem !== null) {
        this.selectCurrentSize();
      }
    }

    disconnectedCallback() {
      let select = this.querySelector("select");
      if (select) {
        select.removeEventListener("change", () => this.handleOptionChange(select));
      }
    }

    selectCurrentSize() {
      setTimeout(() => {
        let currentSize = this.selectElem.dataset.currentSize;
        this.selectElem.value = this.selectElem.querySelector(`option[data-size="${currentSize}"]`).value;
      }, 50);
    }

    handleOptionChange(select) {
      window.location.href = select.value;
    }

    setEventListeners() {
      const select = this.querySelector("select");
      if (select) {
        select.addEventListener("change", () => this.handleOptionChange(select));
      }
    
      const titleSpan = this.querySelector('.color-selector__title .current-color');
      const statusSpan = this.querySelector('.color-selector__title .current-status');
      const selectedSwatch = this.querySelector('a.selected');
    
      function updateStatus(status) {
        if (status === 'pre-order') {
          statusSpan.innerHTML = '(Pre-Order)';
          statusSpan.classList.add('blue');
        } else {
          statusSpan.innerHTML = '';
        }
      }
    
      function handleMouseEvent(event) {
        const colorButton = event.target.closest('[data-color-name]');
        const colorStatusButton = event.target.closest('[data-color-status]');
    
        if (!colorButton || !colorStatusButton) return;
    
        const colorName = colorButton.dataset.colorName;
        const colorStatus = colorStatusButton.dataset.colorStatus;
    
        if (event.type === "mouseover") {
          titleSpan.innerHTML = colorName;
          updateStatus(colorStatus);
        } else if (event.type === "mouseout") {
          titleSpan.innerHTML = selectedSwatch ? selectedSwatch.dataset.colorName : 'select color';
          if (selectedSwatch) {
            updateStatus(selectedSwatch.dataset.colorStatus);
          } else {
            statusSpan.innerHTML = '';
          }
        }
      }
    
      if (selectedSwatch) {
        updateStatus(selectedSwatch.dataset.colorStatus);
      }
    
      this.addEventListener("mouseover", handleMouseEvent);
      this.addEventListener("mouseout", handleMouseEvent);
    }    
    
  }
)